import {
  withTranslation,
} from 'react-i18next';

import RegattaMessagesSectionView from './RegattaMessagesSectionView';

const TranslatedComponent = withTranslation()(RegattaMessagesSectionView);

const Component = TranslatedComponent;

export default Component;
